import React, { useContext, useState, useEffect } from "react";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import GavelIcon from '@mui/icons-material/Gavel';
import { Paper } from '@mui/material';
import { useAuth0 } from "@auth0/auth0-react";
import SettledWindowTransactionsContext from "../../contexts/settled-window-transactions-context";
import UserPendingTransactionsContext from "../../contexts/user-pending-transactions-context";

export const TransfersBottomNavigation = ({ navValue, setNavValue }) => {
  const { user } = useAuth0();
  const {settledWindowTransactionsData} = useContext(SettledWindowTransactionsContext);
  const {userPendingTransactionsData, isLoadingUserPendingTransactionsData} = useContext(UserPendingTransactionsContext);
  const clubId = user['https://tlog-online.co.uk/club_id'];

  const [bidCount, setBidCount] = useState(0);

  useEffect(() => {
    let currentBidCount = 0;

    if(userPendingTransactionsData && userPendingTransactionsData.Items) {
      for(let i = 0; i < userPendingTransactionsData.Items.length; i++) {
          let pendingTransaction = userPendingTransactionsData.Items[i];
          if(pendingTransaction.status != "win" && pendingTransaction.status != "lose") {
              currentBidCount++;
          }
      }
    }
    setBidCount(currentBidCount);
  }, [settledWindowTransactionsData, userPendingTransactionsData, clubId]);

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
      <BottomNavigation
        showLabels
        value={navValue}
        onChange={(event, newValue) => {
          setNavValue(newValue);
        }}
      >
        <BottomNavigationAction label="Make Bid" icon={<GavelIcon />} />
        <BottomNavigationAction label={"My Bids (" + bidCount + ")"} icon={<PersonIcon />} />
        <BottomNavigationAction label="Buy/Sell" icon={<MoveUpIcon />} />
        <BottomNavigationAction label="Manage Team" icon={<GroupIcon />} />
      </BottomNavigation>
    </Paper>
  );
};